<template>
    <div class="container relative mx-auto flex w-full grow flex-col px-4 pb-10">
        <slot />
    </div>
</template>
